export default __webpack_public_path__ + "static/media/resource-image_crpc.3db948b2.png";